// extracted by mini-css-extract-plugin
export default {"sub_header":"sub_header__8b2d035e","item":"item__8b2d035e"};